
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/en/home",
      function () {
        return require("private-next-pages/de/en/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/en/home"])
      });
    }
  